import React from 'react'
import Banner from './Banners/BannerBlueLogo'
import Button from './Button'
import { useHistory } from 'react-router-dom'

export default function MeetingBanner() {

  const history = useHistory();

  return (
    <Banner>
      <h1 className="mx-4 sm:mx-auto pt-6 font-bold text-xl">Would you like to become a future XiViX Partner?</h1>
      <p className="mx-14 sm:mx-auto p-1 text-xs sm:text-sm">Learn more about our novel workflow and partner benefits.</p>
      <div className="pt-4 pb-6"><Button className="" text="SCHEDULE A MEETING" primary="white" onClick={()=> history.push('/professional/become-a-partner')}/></div>
    </Banner>
  )
}
